module.exports = __webpack_public_path__ + "static/media/xavier_barbosa.d8eaab72.jpg";